export const demoFr = {
  // ── DemoPage: Seo ──────────────────────────────────────────────────────────
  'demo.seoTitle': "Jouez maintenant — Entrez à Grymwyrd",
  'demo.seoDescription':
    "Faites tourner le monde, prenez place à la table, forgez un héros Grymwyrd et lancez les dés — une visite guidée du tableau virtuel Grymwyrd.",

  // ── DemoPage: GlobeStep ─────────────────────────────────────────────────────
  'demo.globe.worldAriaLabel': "Le monde de Grymwyrd",
  'demo.globe.spinningWorld': "Rotation du monde…",
  'demo.globe.tagline': "Un monde de fantasy horrifique vivant",
  'demo.globe.arrivedHeading': "Région de Greywick",
  'demo.globe.heading': "Trouvez votre place dans le crépuscule éternel",
  'demo.globe.subheading': "Une table vous attend au cœur du monde. Prenez place et forgez un héros.",
  'demo.globe.enterCta': "Descendez à Grymwyrd",

  // ── DemoPage: AccountStep ───────────────────────────────────────────────────
  'demo.account.heading': "Devenez une part de l'histoire",
  'demo.account.subheading':
    "Créez un compte gratuit pour débloquer l'encyclopédie Grymwyrd complète et sauvegarder le héros que vous allez forger — ou passez en tant qu'invité et explorez dès maintenant.",
  'demo.account.createAccount': "Créer un compte",
  'demo.account.logIn': "Se connecter",
  'demo.account.continueAsGuest': "Continuer en tant qu'invité",

  // ── DemoPage: CreateStep ────────────────────────────────────────────────────
  'demo.create.abilityRollLabel': "{ability} (3d6)",
  'demo.create.initiativeLabel': "Initiative",
  'demo.create.lobbyEyebrow': "Tableau virtuel Grymwyrd · Antichambre",
  'demo.create.heading': "Forgez votre héros",
  'demo.create.subheading': "Un personnage SRD 5.2.1, né de Grymwyrd. Nommez-le, choisissez une vocation et lancez les dés.",
  'demo.create.nameLabel': "Nom",
  'demo.create.namePlaceholder': "Qui devient-il ?",
  'demo.create.chooseCalling': "Choisissez votre vocation",
  'demo.create.keyAbility': "Clé : {ability}",
  'demo.create.abilityScores': "Scores de caractéristiques",
  'demo.create.abilityScoresHint': "— cliquez pour lancer 3d6",
  'demo.create.rollAbilityAria': "Lancer {ability} (3d6)",
  'demo.create.keepStandard': "Ou conservez les 10 standards et plongez.",
  'demo.create.initiativeResult': "Initiative {initiative} — les dés roulent, la table se tourne vers vous…",
  'demo.create.bonesTumble': "Les dés roulent…",
  'demo.create.rollInitiativeCta': "Lancez l'initiative et prenez place",
  'demo.create.chooseCallingHint': "Choisissez une vocation pour prendre place.",

  // ── DemoTableStep ───────────────────────────────────────────────────────────
  'demo.table.errorHeading': "La table n'a pas pu être préparée",
  'demo.table.errorBody': "Le tableau virtuel n'est pas disponible pour le moment.",
  'demo.table.browseLiveTables': "Parcourez plutôt les tables actives",
  'demo.table.settingTable': "Préparation de votre table…",
  'demo.table.connecting': "Connexion au tableau virtuel…",
  'demo.table.heroTable': "Table de {name}",
  'demo.table.firstTable': "Votre première table",
  'demo.table.diceTrayHeading': "Plateau à dés",
  'demo.table.initiativeHeading': "Initiative",
  'demo.table.initiativePrompt': "Lancez les dés pour établir l'ordre de combat.",
  'demo.table.rollForInitiative': "Lancer l'initiative",
  'demo.table.vttEyebrow': "Tableau virtuel Grymwyrd",
  'demo.table.xcardTitle': "Pausez le jeu, anonymement",
  'demo.table.xcard': "X-Card",
  'demo.table.saveHeroTitle': "Créez un compte gratuit pour sauvegarder votre héros",
  'demo.table.saveHero': "Sauvegarder le héros",
  'demo.table.statusLive': "Actif",
  'demo.table.statusConnecting': "Connexion en cours",
  'demo.table.actionLogHeading': "Journal des actions",
  'demo.table.recentRollsHeading': "Derniers lancers",

  // ── DemoTableStep: dock panel titles ────────────────────────────────────────
  'demo.panel.heroSheet': "Feuille de héros",
  'demo.panel.companion': "Compagnon",
  'demo.panel.diceTray': "Plateau à dés",
  'demo.panel.macros': "Macros",
  'demo.panel.diceConsole': "Console à dés",
  'demo.panel.initiative': "Initiative",
  'demo.panel.poll': "Sondage",
  'demo.panel.recentRolls': "Derniers lancers",
  'demo.panel.reference': "Référence",
  'demo.panel.chat': "Tchat",
  'demo.panel.handouts': "Fiches",
  'demo.panel.safety': "Sécurité",
  'demo.panel.sceneAndCues': "Scène et indices",
  'demo.panel.replay': "Rejeu",
  'demo.panel.recap': "Résumé",
  'demo.panel.actionLog': "Journal des actions",

  // ── DemoTableStep: ActionBar ────────────────────────────────────────────────
  'demo.action.melee': "Mêlée",
  'demo.action.cast': "Lancer",
  'demo.action.move': "Se déplacer",
  'demo.action.block': "Bloquer",
  'demo.action.chooseTarget': "Choisissez une cible pour {action}…",
  'demo.action.controlling': "Contrôle :",
  'demo.action.cannotAct': "{label} ne peut agir — sélectionnez une créature, un joueur, un véhicule ou un PNJ.",
  'demo.action.selectActionable': "Sélectionnez un objet actionnable pour agir avec lui.",
  'demo.action.cancel': "Annuler",

  // ── DemoTableStep: InitiativeTracker ────────────────────────────────────────
  'demo.tracker.rollingOrder': "Établissement de l'ordre…",
  'demo.tracker.combatant': "Combattant {n}",
  'demo.tracker.previousTurn': "Tour précédent",
  'demo.tracker.round': "Round {round}",
  'demo.tracker.endCombatTitle': "Terminer le combat",
  'demo.tracker.end': "Terminer",
  'demo.tracker.nextTurnTitle': "Tour suivant",
  'demo.tracker.next': "Suivant",
  'demo.tracker.hitPoints': "Points de vie",
  'demo.tracker.reduceHp': "Réduire les PV de {name}",
  'demo.tracker.raiseHp': "Augmenter les PV de {name}",
  'demo.tracker.addStatusEffect': "Ajouter un effet de statut",
  'demo.tracker.removeFromOrder': "Retirer de l'ordre",
  'demo.tracker.removeFromOrderTitle': "Retirer de l'ordre de combat",
  'demo.tracker.removeCondition': "Retirer {name}",
  'demo.tracker.roundsShort': "{n}r",

  // ── DemoTableStep: XCardOverlay ─────────────────────────────────────────────
  'demo.xcard.ariaLabel': "La table est en pause",
  'demo.xcard.heading': "La table est en pause",
  'demo.xcard.body':
    "Quelqu'un a levé la X-Card. On pause, sans question et sans culpabilité. Quand tout le monde est prêt, on reprend.",
  'demo.xcard.resume': "On est prêt — reprendre",

  // ── DemoTableStep: HandoutsCard ─────────────────────────────────────────────
  'demo.handouts.heading': "Fiches",
  'demo.handouts.titlePlaceholder': "Titre (facultatif)",
  'demo.handouts.bodyPlaceholder': "Une note, un indice, une narration…",
  'demo.handouts.push': "Envoyer à la table",
  'demo.handouts.whispered': "Chuchoté",
  'demo.handouts.dismiss': "Rejeter la fiche",

  // ── DemoTableStep: SafetyCard / SafetyList ──────────────────────────────────
  'demo.safety.heading': "Sécurité",
  'demo.safety.description': "Des limites que nous ne franchirons pas ; des voiles que nous tirons. Partagés par toute la table, jamais attribués.",
  'demo.safety.linesLabel': "Limites (interdit absolu)",
  'demo.safety.veilsLabel': "Voiles (fondu au noir)",
  'demo.safety.removeItem': "Retirer « {item} »",
  'demo.safety.addLinePlaceholder': "Ajouter une limite…",
  'demo.safety.addVeilPlaceholder': "Ajouter un voile…",
  'demo.safety.addLine': "Ajouter une limite",
  'demo.safety.addVeil': "Ajouter un voile",

  // ── DemoTableStep: CharacterSheetPanel ──────────────────────────────────────
  'demo.sheet.heading': "Feuille de héros",
  'demo.sheet.hp': "PV",
  'demo.sheet.ac': "CA",
  'demo.sheet.classLevel': "{className} · Nv 1",

  // ── CompanionPanel ──────────────────────────────────────────────────────────
  'demo.companion.heading': "Appareil compagnon",
  'demo.companion.description':
    "Appairez un téléphone ou une tablette comme second écran en lecture seule — l'initiative, les derniers lancers et la scène se reflètent sur l'appareil. Révocation possible à tout moment.",
  'demo.companion.pairDevice': "Appairer un appareil",
  'demo.companion.qrAriaLabel': "Code QR d'appairage du compagnon",
  'demo.companion.copied': "Copié",
  'demo.companion.copyLink': "Copier le lien",
  'demo.companion.revoke': "Révoquer",

  // ── MacroTray ───────────────────────────────────────────────────────────────
  'demo.macros.heading': "Macros à dés",
  'demo.macros.dismissError': "Rejeter l'erreur",
  'demo.macros.newMacro': "Nouvelle macro",
  'demo.macros.namePlaceholder': "Nom (pas de points)",
  'demo.macros.labelPlaceholder': "Label du bouton (facultatif)",
  'demo.macros.save': "Sauvegarder la macro",
  'demo.macros.noDots': "Les noms de macros ne peuvent pas contenir de points.",

  // ── PollBoard ───────────────────────────────────────────────────────────────
  'demo.poll.heading': "Sondage",
  'demo.poll.questionPlaceholder': "Posez une question à la table…",
  'demo.poll.optionPlaceholder': "Option {n}",
  'demo.poll.removeOption': "Retirer l'option {n}",
  'demo.poll.addOption': "Ajouter une option",
  'demo.poll.openPoll': "Ouvrir le sondage",
  'demo.poll.live': "Actif",
  'demo.poll.closed': "Sondage fermé",
  'demo.poll.vote': "Voter",
  'demo.poll.closePoll': "Fermer le sondage",
  'demo.poll.startNewPoll': "Commencer un nouveau sondage",

  // ── RecapCard ───────────────────────────────────────────────────────────────
  'demo.recap.heading': "Résumé de session",
  'demo.recap.tagline': "L'histoire de votre table, quand la poussière retombe.",
  'demo.recap.gathering': "Recueil de l'histoire…",
  'demo.recap.getRecap': "Obtenir le résumé de session",
  'demo.recap.notableRolls': "Lancers notables",
  'demo.recap.copied': "Copié !",
  'demo.recap.share': "Partager",

  // ── ReferenceCard / ReferenceDetail ─────────────────────────────────────────
  'demo.reference.heading': "Référence",
  'demo.reference.searchPlaceholder': "Recherchez un monstre, un sort, une règle…",
  'demo.reference.searchAria': "Recherchez l'encyclopédie pour partager",
  'demo.reference.typeToSearch': "Tapez au moins deux lettres pour chercher dans l'encyclopédie vivante.",
  'demo.reference.searching': "Recherche…",
  'demo.reference.open': "Ouvrir {title}",
  'demo.reference.share': "Partager",
  'demo.reference.dismiss': "Rejeter la référence",
  'demo.reference.backToSearch': "Retour à la recherche",
  'demo.reference.loadingContent': "Chargement du contenu…",
  'demo.reference.notOwned':
    "Vous ne possédez pas encore ce livre. La référence complète se déverrouille une fois que vous l'ajoutez à votre bibliothèque.",
  'demo.reference.contentDown': "Le contenu n'est pas disponible pour le moment. Réessayez dans un instant.",
  'demo.reference.noAdditionalContent': "Aucun contenu supplémentaire pour cette référence.",
  'demo.reference.noLinkedContent': "Aucun contenu de livre lié pour cette référence.",
  'demo.reference.shareToTable': "Partager à la table",

  // ── ReplayTimeline ──────────────────────────────────────────────────────────
  'demo.replay.heading': "Rejeu",
  'demo.replay.tagline': "Remontez la session étape par étape.",
  'demo.replay.loading': "Chargement…",
  'demo.replay.loadReplay': "Charger le rejeu",
  'demo.replay.loadMore': "Charger plus",

  // ── RollFeed / VisibilityToggle ─────────────────────────────────────────────
  'demo.dice.heading': "Dés",
  'demo.dice.dismissError': "Rejeter l'erreur",
  'demo.dice.labelPlaceholder': "Attaque (facultatif)",
  'demo.dice.roll': "Lancer",
  'demo.dice.rolledForReal': "Je l'ai vraiment lancé",
  'demo.dice.totalPlaceholder': "Total (requis)",
  'demo.dice.physNotationPlaceholder': "1d20+5 (facultatif)",
  'demo.dice.physLabelPlaceholder': "Label (facultatif)",
  'demo.dice.logPhysical': "Enregistrer le lancer physique",
  'demo.dice.onTable': "🎲 sur la table",
  'demo.dice.private': "Privé",
  'demo.dice.public': "Public",
  'demo.dice.rolledPrivately': "lancé en privé",
  'demo.dice.exploded': "explosé",

  // ── SceneBoard ──────────────────────────────────────────────────────────────
  'demo.scene.heading': "Scène et indices",
  'demo.scene.current': "Scène : {scene}",
  'demo.scene.cueSuffix': "— indice : {cue}",
  'demo.scene.noScene': "Aucune scène définie",
  'demo.scene.oneShotCues': "Indices ponctuels",

  // ── TableMap ────────────────────────────────────────────────────────────────
  'demo.map.tokenAt': "{label} à {x},{y}",
  'demo.map.tile': "Tuile {x},{y}",
  'demo.map.fogged': "Masqué",
  'demo.map.battleMap': "Carte de bataille",
  'demo.map.gm': "MJ",
  'demo.map.noMap': "Aucune carte",
  'demo.map.uploadedMap': "Carte téléchargée",
  'demo.map.uploadTitle': "Téléchargez une image de carte comme fond du canevas",
  'demo.map.reading': "Lecture…",
  'demo.map.upload': "Télécharger",
  'demo.map.size': "Taille",
  'demo.map.shrinkMap': "Réduire la carte",
  'demo.map.growMap': "Agrandir la carte",
  'demo.map.widthShort': "L",
  'demo.map.narrowMap': "Rétrécir la carte",
  'demo.map.widenMap': "Élargir la carte",
  'demo.map.heightShort': "H",
  'demo.map.shortenMap': "Raccourcir la carte",
  'demo.map.heightenMap': "Allonger la carte",
  'demo.map.fitTitle': "Réinitialiser la position + étirer pour remplir la grille",
  'demo.map.fit': "Adapter",
  'demo.map.lock': "Verrouiller",
  'demo.map.adjust': "Ajuster",
  'demo.map.fogOn': "Brouillard ACTIVÉ — cliquez pour désactiver",
  'demo.map.fogOff': "Brouillard DÉSACTIVÉ — cliquez pour activer",
  'demo.map.fog': "Brouillard",
  'demo.map.exitPaintTitle': "Quitter le mode peinture",
  'demo.map.paintTitle': "Peindre le brouillard — cliquez ou glissez les cellules pour révéler/masquer",
  'demo.map.exitPaint': "Quitter la peinture",
  'demo.map.paint': "Peindre",
  'demo.map.hexGridTitle': "Grille hexagonale — cliquez pour carré",
  'demo.map.squareGridTitle': "Grille carrée — cliquez pour hexagonale",
  'demo.map.hex': "Hexagonale",
  'demo.map.zoomOut': "Dézoomer",
  'demo.map.zoomLevel': "Niveau de zoom",
  'demo.map.zoomIn': "Zoomer",
  'demo.map.resetView': "Réinitialiser la vue",
  'demo.map.reset': "Réinitialiser",

  // ── DockPanel ───────────────────────────────────────────────────────────────
  'demo.dock.expand': "Développer {title}",
  'demo.dock.collapse': "Replier {title}",

  // ── LeaveTableGuard ─────────────────────────────────────────────────────────
  'demo.leave.ariaLabel': "Quitter la table ?",
  'demo.leave.heading': "Quitter la table ?",
  'demo.leave.body':
    "Vous êtes en plein milieu d'une partie. C'est une table d'invité — si vous partez maintenant, la session se termine et votre héros est perdu.",
  'demo.leave.stay': "Rester à la table",
  'demo.leave.leaveAnyway': "Partir quand même",
}
